import { createInteractionEvent, createOutcomeEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import reasons from '../../../components/ListYourPropertyPage/EligibilityCatch/reasons';
import { AAPLOCATION_PAGE } from '../../../components/PageFlow/PageList';
import { PROPERTY_NAME_ERROR_MESSAGES, ADDRESS_ERROR_MESSAGES } from '../../../constants/common';

const isPropertyNameError = (message) => PROPERTY_NAME_ERROR_MESSAGES.includes(message);
const isAddressError = (message) => ADDRESS_ERROR_MESSAGES.includes(message);

const onError = (props) => (error) => {
    const {
        onSubmitError,
        setEligibilityStatus,
        pageFlow,
        pageName,
        // add trigger in parent props
        trigger
    } = props;

    trigger('outcome', createOutcomeEvent('property_creation.failed', 'AddProperty', 'AAP'));
    onSubmitError(error.message);

    if (isPropertyNameError(error.message)) {
        // Stay on the property-info page so the user can correct the name.
        return;
    }

    if (isAddressError(error.message)) {
        // Send user back to the location step to fix their address.
        pageFlow.navigate(AAPLOCATION_PAGE);
        return;
    }

    // AAP flow always defaults to TIMEOUT page
    setEligibilityStatus(reasons.TIMEOUT);
    pageFlow.next(pageName);
};

const onComplete = (props) => ({ data }) => {
    const {
        setEligibilityStatus,
        pageFlow,
        setPropertyId,
        // add trigger in parent props
        trigger,
        clearCompetitorUrl,
        clearSubmarketId,
        clearIsSelfServe,
        pageName
    } = props;
    const {
        lpsContact
    } = data.createContact;

    clearCompetitorUrl();
    clearSubmarketId();
    clearIsSelfServe();
    // what happens when we get no property Id???
    if (!lpsContact.propertyId) {
        trigger('outcome', createOutcomeEvent('property_creation.failed', 'AddProperty - no pId', 'AAP'));
        setEligibilityStatus(reasons.TIMEOUT);
        pageFlow.next(pageName);
        return;
    }
    setPropertyId(lpsContact.propertyId);
    trigger('interaction', createInteractionEvent('next_button.initiated', 'add_a_property', 'AddProperty', '', '2.4.0'));
    trigger('outcome', createOutcomeEvent('property_creation.succeeded', 'AddProperty'));
    pageFlow.next(pageName);
};

export default {
    onError,
    onComplete
};
